import * as _ from "lodash";
import * as log from "loglevel";
import * as React from "react";

import { inject, observer, Provider } from "mobx-react";
import { Button, Form, Input, Popup } from "semantic-ui-react";
import { AuthStore } from "../../stores/auth-store";
import { MFAType, User } from "../../stores/models/user";
import { UserStore } from "../../stores/user-store";
import { LoadingSpinner } from "../common/loading-spinner";
import { PasswordModal } from "./password-modal";

declare var toastr: any;

interface IProfileEditorProps {
	userStore?: UserStore;
	authStore?: AuthStore;
}

interface IProfileEditorState {
	marketingOptInAccepted?: boolean;
	notificationOptInAccepted?: boolean;
	mfaEnabled?: boolean;
	mfaType?: MFAType;
	errorMessage?: string;
	firstName?: string;
	lastName?: string;
	company?: string;
}

@inject("userStore", "authStore") @observer
export class ProfileEditor extends React.Component<IProfileEditorProps, IProfileEditorState>{
	constructor(props, state) {
		super(props, state);

		this.state = { "firstName": "", "lastName": "", "company": "" };

		this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
		this.handleProfileChange = this.handleProfileChange.bind(this);
		this.saveProfileChange = _.debounce(this.saveProfileChange.bind(this), 400);
	}

	async componentDidMount() {
		await this.props.authStore.loadFullUser();
		this.loadState(this.props);
	}

	async componentWillReceiveProps(nextProps: IProfileEditorProps) {
		if (nextProps.authStore.userId !== this.props.authStore.userId) {
			await this.props.authStore.loadFullUser();
			this.loadState(nextProps);
		}
	}

	loadState(props: IProfileEditorProps) {
		this.setState({
			"marketingOptInAccepted": props.authStore.user.marketingOptInAccepted,
			"notificationOptInAccepted": props.authStore.user.notificationOptInAccepted,
			"firstName": props.authStore.firstName,
			"lastName": props.authStore.lastName,
			"company": props.authStore.company,
			"mfaEnabled": props.authStore.user.mfaEnabled,
			"mfaType": props.authStore.user.mfaType,
		});
	}

	async handleProfileChange(e: any, { name, value }) {
		this.setState({ [name]: value });
		this.props.authStore.updateProperty(name, value);
		await this.saveProfileChange();
	}

	async saveProfileChange() {
		try {
			await this.props.authStore.saveProfile();
			this.loadState(this.props);
			toastr.success("Change Saved");
		}
		catch (err) {
			log.error(err);
			this.setState({ "errorMessage": err.message });
		}
	}

	async handleCheckboxChange(e: any, { name }) {
		let value = !this.state[name];
		this.setState({ [name]: value });
		this.props.authStore.user.updateProperty(name, value);
		if(name === "mfaEnabled" && value === true){
			this.props.authStore.user.updateProperty("mfaType", 0);
			this.setState({ mfaType: MFAType.email });
		}

		try {
			await this.props.authStore.user.save();
			this.loadState(this.props);
			toastr.success("Change Saved");
		}
		catch (err) {
			log.error(err);
			this.setState({ "errorMessage": err.message });
		}
	}


	render() {
		const { authStore } = this.props;
		let mfaOptions = [
			{"key": 0, "value": 0, "text": "Email"}
		];
		return (
			<div style={{ "marginTop": "105px", "marginLeft": "150px", "marginRight": "150px" }}>
				<h1>{this.state.firstName} {this.state.lastName} ({authStore.user.username})</h1>
				{this.props.authStore.user.accountType !== 0 &&
					<Form>
						<Popup hoverable
							content={<span>Updating email is not available at the present time. Please email <a href="mailto:projects@jibunu.com">projects@jibunu.com</a> for assistance.</span>}
							trigger={
								<Form.Field inline>
									<label>Email</label>
									<Input disabled value={this.props.authStore.user.username} onChange={() => { }} />
								</Form.Field>} />
						<Form.Input inline label="First Name" name="firstName" value={this.state.firstName} onChange={this.handleProfileChange} />
						<Form.Input inline label="Last Name" name="lastName" value={this.state.lastName} onChange={this.handleProfileChange} />
						<Form.Input inline label="Company" name="company" value={this.state.company} onChange={this.handleProfileChange} />

						<Form.Checkbox label="I would like to receive occasional marketing emails which may include new technology updates and discount offers." name="marketingOptInAccepted" checked={this.state.marketingOptInAccepted} onChange={this.handleCheckboxChange} />
						<Form.Checkbox label="I would like to receive an email when I have been given access to additional JUMP projects." name="notificationOptInAccepted" checked={this.state.notificationOptInAccepted} onChange={this.handleCheckboxChange} />

						<Form.Checkbox label="Enabled MFA for my Account" name="mfaEnabled" checked={this.state.mfaEnabled} onChange={this.handleCheckboxChange} />
						{this.state.mfaEnabled && 
							<Form.Dropdown label="MFA Type:" options={mfaOptions} value={this.state.mfaType} disabled />
						}

						<PasswordModal />
					</Form>

				}
				{this.state.errorMessage &&
					<div className="ui red icon message">
						<i className="warning sign icon"></i>
						{this.state.errorMessage}
					</div>
				}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/users/profile-editor.tsx